import { InjectionToken, inject } from '@angular/core';

import { NonRootToken } from '@frontend/sports/host-app/sports-product/feature/non-root-token';

import { SportsTheme } from './themes';

export const CURRENT_THEME_TOKEN = new InjectionToken<SportsTheme>('CURRENT_THEME');
export const IS_ROBOT_TOKEN = new InjectionToken<boolean>('IS_ROBOT_TOKEN');

export const injectCurrentTheme = () => inject(NonRootToken(CURRENT_THEME_TOKEN));
export const injectIsRobot = () => inject(NonRootToken(IS_ROBOT_TOKEN));
